<template>
  <div class="not-filter-editor">
    <FilterEditor
      v-model="filter"
      v-bind="subObjectBinds" />
  </div>
</template>

<script>

  import ObjectEditorMixin from '@/components/reports/config/common/ObjectEditorMixin'
  import { mapChildren } from '@/components/reports/config/common/objectUtil'

  export default {
    name: 'OrFilterEditor',
    mixins: [
      ObjectEditorMixin,
    ],
    computed: {
      ...mapChildren({
        filter: 'filter',
      }),
    },
  }

</script>

<style lang="scss" scoped>

.not-filter-editor {
  display: flex;
  flex-direction: column;
}

</style>
